import { FormControl, MenuItem, Select, Typography, Button, Box, TextField } from '@mui/material';
import { RedTheme } from 'common/global';
import { DropDownIcon } from 'common/components';
import { ReactComponent as CrossIcon } from 'common/assets/images/CrossIcon.svg';
import { DeletePopup } from 'TAP/components/DeletePopup';
import { useState } from 'react';
import { ShareFilterAdminSelectionPopup } from './ShareFilterAdminSelectionPopup';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import { TapGlobalMessages } from 'TAP/global';
import { labels } from 'common/global/constants';

export const FavDropDown = ({
  options,
  selectFav,
  indicator,
  editModeNameValidation,
  handleAdminStatusChange,
  handleFavDelete,
  isEditingMode,
  handleEditSelect,
  handleInputFilterNameChange,
}) => {
  let redtheme = RedTheme;
  const [openPopup, setOpenPopup] = useState(false);
  const [deleteFilterName, setDeleteFiltername] = useState('');
  const [openShareFilterPopup, setOpenShareFilterPopup] = useState(false);
  const [favouriteFilterToShare, setFavouriteFilterToShare] = useState('');

  const handleDeletePopup = (e, value) => {
    setDeleteFiltername(value);
    e.stopPropagation(); //Stop the parent action
  };

  const handleShareFavourite = (e, value) => {
    setFavouriteFilterToShare(value);
    e.stopPropagation();
  };

  return (
    <>
      <FormControl
        variant='standard'
        data-testid='status_filter'
        sx={{ width: '100%', mt: 2, fontFamily: '"JohnsonText-Medium"' }}
      >
        {isEditingMode ? (
          <TextField
            id='edit-field'
            defaultValue={selectFav}
            variant='standard'
            inputProps={{ maxLength: 100, 'aria-label': 'description' }}
            onChange={(event) => handleInputFilterNameChange(event)}
            error={editModeNameValidation}
            helperText={editModeNameValidation ? TapGlobalMessages.textFieldValidationMessage : ''}
          />
        ) : (
          <Select
            IconComponent={DropDownIcon}
            displayEmpty={true}
            value={selectFav}
            onChange={(e) => {
              const selectedValue = e.target.value;
              const selectedOption = options.find((opt) => opt.filterName === selectedValue);
              const user_id = selectedOption?.user_id;
              const customEvent = {
                target: {
                  value: selectedValue,
                  user_id: user_id,
                },
              };
              handleAdminStatusChange(customEvent, indicator);
            }}
            renderValue={(selected) => {
              if (!selected || selected?.length === 0) {
                return (
                  <Typography
                    sx={{
                      color: redtheme.palette.fontColor.gray_orange,
                      fontSize: '16px',
                      fontWeight: 400,
                    }}
                  >
                    {labels.savedFavTxt}
                  </Typography>
                );
              }
              return selected;
            }}
          >
            <MenuItem value=''>
              <em>None</em>
            </MenuItem>
            {options?.map((obj, index) => (
              <MenuItem key={index} value={obj.filterName}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'space-between',
                  }}
                >
                  {/* Filter Name */}
                  <Typography
                    sx={{
                      fontFamily: '"JohnsonText-Medium"',
                      fontSize: '16px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '55%',
                    }}
                  >
                    {obj.filterName}
                  </Typography>

                  {/* Shared Count */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {obj.sharedBy !== '' ? (
                      <Typography
                        sx={(theme) => ({
                          fontFamily: '"JohnsonText-Medium"',
                          fontSize: '14px',
                          color: theme.palette.text.primary,
                        })}
                      >
                        {`${labels.sharedByTxt} ${obj.sharedBy}`}
                      </Typography>
                    ) : (
                      <>
                        {obj.shareCount > 0 && (
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              mr: '12px',
                            }}
                          >
                            <PeopleOutlinedIcon fontSize='medium' />
                            <Typography
                              sx={(theme) => ({
                                fontSize: '14px',
                                fontFamily: '"JohnsonText-Medium"',
                                minWidth: '20px',
                                textAlign: 'right',
                                color: theme.palette.text.primary,
                              })}
                            >
                              {obj.shareCount}
                            </Typography>
                          </Box>
                        )}

                        <Button
                          onClick={() => handleEditSelect()}
                          startIcon={<ModeEditOutlinedIcon />}
                          sx={(theme) => ({
                            color: theme.palette.text.primary,
                            minWidth: 'auto',
                          })}
                        />

                        <Button
                          onClick={(e) => {
                            handleShareFavourite(e, obj.filterName);
                            setOpenShareFilterPopup(true);
                          }}
                          startIcon={<ShareOutlinedIcon />}
                          sx={(theme) => ({
                            color: theme.palette.text.primary,
                            minWidth: 'auto',
                          })}
                        />

                        <Button
                          onClick={(e) => {
                            handleDeletePopup(e, obj.filterName);
                            setOpenPopup(true);
                          }}
                          startIcon={<CrossIcon />}
                          sx={{
                            minWidth: 'auto',
                          }}
                        />
                      </>
                    )}
                  </Box>
                </Box>
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
      <DeletePopup
        popupHeader={labels.deleteFavHeaderTxt}
        SubHeader={labels.deleteFavMsg}
        leftBtnText={labels.cancelBtnText}
        rightBtnText={labels.deleteBtnText}
        open={openPopup}
        deleteFilterName={deleteFilterName}
        handleFavDelete={handleFavDelete}
        handleClose={() => setOpenPopup(false)}
      />
      <ShareFilterAdminSelectionPopup
        popupHeader={labels.shareFavTxt}
        leftBtnText={labels.cancelBtnText}
        rightBtnText={labels.shareBtnText}
        open={openShareFilterPopup}
        favName={favouriteFilterToShare}
        handleClose={() => {
          setOpenShareFilterPopup(false);
          setFavouriteFilterToShare('');
        }}
      />
    </>
  );
};
